import "./App.css";
import Home from "./PortfolioContainer/Home/Home";
import AboutMe from "./PortfolioContainer/AboutMe/AboutMe";
import Resume from "./PortfolioContainer/Resume/Resume";
import Testimonial from "./PortfolioContainer/Testimonial/Testimonial";
import ContactMe from "./PortfolioContainer/ContactMe/ContactMe";
import Navbar from "./PortfolioContainer/Navbar/Navbar";
function App() {
  console.log(typeof process.env.REACT_APP_user_id);
  return (
    <div className="App">
      <Navbar />
      <Home />
      <AboutMe />
      <Resume />
      <Testimonial />
      <ContactMe />
    </div>
  );
}

export default App;
